// frontend_react/src/services/supplierInvoiceApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const getSupplierInvoice = (invoiceUuid, { companyUuid } = {}) =>
  api.get(`/supplier-invoices/${invoiceUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const processSupplierInvoice = (invoiceUuid, { companyUuid } = {}) =>
  api.post(
    `/supplier-invoices/${invoiceUuid}/process`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const validateSupplierInvoice = (invoiceUuid, lines, { companyUuid } = {}) =>
  api.post(
    `/supplier-invoices/${invoiceUuid}/validate`,
    { lines },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const searchProducts = (query, { companyUuid } = {}) =>
  api.get("/activities/products/search", {
    params: { q: query },
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const smartMatchProduct = (payload, { companyUuid } = {}) =>
  api.post("/activities/products/smart-match", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const uploadSupplierInvoice = (formData, { companyUuid } = {}) =>
  api.post("/supplier-invoices/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...buildCompanyScopeHeaders(companyUuid),
    },
  });

export const createProductFromSupplierInvoiceLine = (payload, { companyUuid } = {}) =>
  api.post("/activities/products/from-supplier-invoice-line", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const learnSupplierInvoiceMatching = (payload, { companyUuid } = {}) =>
  api.post("/supplier-invoices/learning", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });